<!--Load the font icons package:-->
<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />
<!-- <form [formGroup]="form" (ngSubmit)="onSaveAction()" class="k-form-inline"> -->
<form [formGroup]="permissionForm"  class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="entity">Entity</label>
    <div class="col-8">
      <input type="text" id="entity" formControlName="entity" class="form-control" appAutoFocus>
      <div *ngIf="entity?.invalid" class="alert alert-danger">
        <div *ngIf="entity?.errors?.['required']">Entity is required.</div>
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="action">Action</label>
    <div class="col-8">
      <input type="text" id="action" formControlName="action" class="form-control">
      <div *ngIf="action?.invalid" class="alert alert-danger">
        <div *ngIf="action?.errors?.['required']">Action is required.</div>
      </div>
    </div>
  </div>

  <div class="k-actions k-actions-horizontal k-actions-stretched k-dialog-actions k-window-actions ng-star-inserted">
    <button kendoButton type="submit" (click)="onSaveAction()" class="btn btn-primary" [disabled]="permissionForm.invalid">
      Save
    </button>
    <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
  </div>

</form>
